/* eslint-disable complexity */
import { yupResolver } from '@hookform/resolvers/yup'
import { Stack } from '@mui/material'
import React, { FC, useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { useSelectPricingMatrix } from '../../../hooks/useSelectPricingMatrix/useSelectPricingMatrix'
import { LabelsPartsInfo } from '../../../models/Labels'
import { CannedJobPartLookupInfo, PartTaxonomy } from '../../../sdk'
import {
  ControlledMuiCheckboxSingle,
  ControlledMuiTextField
} from '../../FormField'
import { PartTaxonomyAutoComplete } from '../../PartTaxonomyAutoComplete/PartTaxonomyAutoComplete'
import { DEFAULT_NEW_CANNEDJOB_PART_LOOKUP } from '../defaultValues'
import { VALIDATE_CANNEDJOB_PART_LOOKUP } from '../validation'

type Props = {
  formId: string
  defaultValues: CannedJobPartLookupInfo | undefined
  onSubmit: SubmitHandler<CannedJobPartLookupInfo>
}

export const CannedJobPartLookupForm: FC<Props> = ({
  formId,
  onSubmit,
  defaultValues
}) => {
  const { handleSubmit, control, setValue } = useForm<CannedJobPartLookupInfo>({
    mode: 'onBlur',
    defaultValues: defaultValues || {
      ...DEFAULT_NEW_CANNEDJOB_PART_LOOKUP
    },
    resolver: yupResolver(VALIDATE_CANNEDJOB_PART_LOOKUP)
  })

  const [selectedTaxonomy, setSelectedTaxonomy] = React.useState<
    PartTaxonomy | undefined
  >(defaultValues?.partTaxonomy)

  const {
    selectedPartsMatrixId,
    SelectPriceLevelComponent,
    SelectPartsMatrixComponent
  } = useSelectPricingMatrix('', '', defaultValues?.partsMatrix || '', {
    partTaxonomy: selectedTaxonomy
  })

  useEffect(() => {
    setValue('partsMatrix', selectedPartsMatrixId)
  }, [selectedPartsMatrixId, setValue])

  return (
    <Stack spacing={2} mt={2}>
      <form
        onSubmit={handleSubmit((data) => {
          onSubmit({ ...data, partTaxonomy: selectedTaxonomy })
        })}
        id={formId}>
        <Stack spacing={2}>
          <ControlledMuiTextField
            name="searchTerm"
            control={control}
            label={LabelsPartsInfo.searchTerm}
            required
            fullWidth
          />
          <SelectPriceLevelComponent variant={undefined} />
          <SelectPartsMatrixComponent variant={undefined} />
          <ControlledMuiCheckboxSingle
            control={control}
            name="taxExempt"
            label={LabelsPartsInfo.taxExempt}
          />
        </Stack>
      </form>
      <PartTaxonomyAutoComplete
        {...{ selectedTaxonomy, setSelectedTaxonomy }}
      />
    </Stack>
  )
}
